import camera from './black-grey-camera-alex-andrews.jpg'
import reel from './fishing-reel-brent-keane.jpg'
import drive from './hard-drive-sergei-starostin.jpg'
import kettle from './kettle-cottonbro.jpg'
import bike from './mountain-bike-jenda-kubeš.jpg'
import perfume from './perfume-dids.jpg'
import toolbox from './toolbox-anastasia-shuraeva.jpg'
import basket from './wicker-basket-vinícius-estevão.jpg'

const products = {
    camera,
    reel,
    drive,
    kettle,
    bike,
    perfume,
    toolbox,
    basket
}

export default products